import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationOverlaySmallDialogComponent } from './operation-overlay-small-dialog/operation-overlay-small-dialog.component';
import { OperationOverlaySmallService } from './operation-overlay-small.service';

@NgModule({
    imports: [CommonModule],
    declarations: [OperationOverlaySmallDialogComponent],
    providers: [OperationOverlaySmallService],
})
export class OperationOverlaySmallModule {}
